export default __webpack_public_path__ + "static/media/hamza-shah.637a7d4c.jpeg";